// Importing necessary dependencies and styles
import './App.css';
import  { useState } from 'react';
import {Top} from './TOP.js'

// Main App component
function App() {
  // initialize states of variables
  const [weight, setweight] = useState(0);
  const [height, setheight] = useState(0);
  const [BMI, setBMI] = useState('');
  const [message, setmessage] = useState('');
  const [w, setw] = useState('');
  const [name, setname] = useState('');
  const [Bmess, setBmess] = useState('')
  const [flag, setflag] = useState(true)
  const [added, setadded] = useState(false)
  const [products, setProducts] = useState([]);

  // Function to set products and show the list
  const setProductsAndShowList = (productList) => {
    setProducts(productList);
    setadded(true);
  };

  // Arrays of advice for different BMIs
  const products1 = [{
    answer1: "Consume a balanced and nutrient densed diet", 
    answer2: "Include Protein rich foods like lean meat", 
    answer3: "Engage in regular exercise like strength training", 
    answer4: "Eat more frequent but smaller balanced meals",
    answer5: "Have patience, monitor your gains regularly"
  }]
  const products2 = [{
    answer1: "Balanced diet: Eat variety of foods and control portion size",
    answer2: "Engage in physical activity daily like Cardio",
    answer3: "Have an adequate amount of sleep",
    answer4: "Practice mindful eating",
    answer5: "Limit sugary and processed foods"
  }]
  const products3 = [{
    answer1: "Stay hydrated regularly",
    answer2: "Practice mindful body practices like meditation",
    answer3: "Stay postive as it is directly linked with health"
  }]

  // Logic to render the list based on BMI
  function Lst() {

    let listItems;
  
    if (added && products.length > 0) {
      listItems = products.map(function (product) {
        return (
          <span className='aa'>
            <ul>
              {Object.values(product).map((answer, index) => (
                <li key={index}>{answer}</li>
              ))}
            </ul>
          </span>
        );
      });
    }
    return <span>{listItems}</span>;
  }

  // Setting of name and providing advice based on BMI
  let SetName = (e) => {
    e.preventDefault();
    if ( name ==="" && flag === true ) {
      alert("Please enter a valid name, weight and height")
    } else if (name ==="" && flag === false) {
      alert("Please enter a valid name")
    } else if(name !=="" && flag === true) {
      alert("Please enter a valid weight and height")
    } else {
      setname(name.toString(1));
    
      let text1 = " since you are underweight so you can try the following methods:"
      let text2 = " since you are overweight so you can try the following methods:"
      let message;
      if ( BMI < 18.5 ) {
        setProductsAndShowList(products1);
        message = "Hi " + name + text1;
      } else if ( BMI >= 18.5 && BMI < 25 ) {
        setProductsAndShowList(products3);
        message = "Hi " + name + " You are perfectly healthy. Keep it up!";
      } else if ( BMI >= 25 ) {
        setProductsAndShowList(products2);
        message = "Hi " + name + text2;
      }
      setBmess(message);
      
    } 
  };

  // Weight conversion
  let CalcWeight = (e) => {
    e.preventDefault();
    if ( w === "" ) {
      alert("Please enter a valid weight")
    } else {
      let wt = (w * 2.205);
      setw(wt.toFixed(1));
    }
  }

  // BMI calculation
  let calcBMI = (e) => {

    e.preventDefault();
    
    if ( weight === 0 || height === 0 ) {
      alert("Please enter a valid weight and height")
    } else {
      setflag(false);
      let bmi = (weight / (height * height) * 703 );
      setBMI(bmi.toFixed(1));

      // Determining the message depending on BMI
      if (bmi < 18.5) {
        setmessage("You are underweight")
      } else if ( bmi >= 18.5 && bmi < 25) {
        setmessage("You are healthy")
      } else {
        setmessage("You are overweight")
      }

      // Check if the BMI contains numbers and apply glow effect
      const bmiInput = e.target.elements[0];
      if (/\d/.test(bmi)) {
        bmiInput.classList.add("has-numbers");
      } else {
        bmiInput.classList.remove("has-numbers");
      }
    }
  }

  // Function to validate numbers-only input
  const validateNumbers = (value) => {
    return /^\d+(\.\d*)?$/.test(value);
  };

  // Function to validate letters-only input
  const validateLetters = (value) => {
    return /^[A-Za-z]+$/.test(value);
  };

  // Function to handle input change for numbers-only input
  const handleNumbersWInputChange = (e) => {
    const newValue = e.target.value;
    if (!validateNumbers(newValue)) {
      e.target.classList.add("input-error");
    } else {
      e.target.classList.remove("input-error");
      setweight(newValue);
    }
  };

  const handleNumbersHInputChange = (e) => {
    const newValue = e.target.value;
    if (!validateNumbers(newValue)) {
      e.target.classList.add("input-error");
    } else {
      e.target.classList.remove("input-error");
      setheight(newValue);
    }
  };

  // Function to handle input change for letters-only input
  const handleLettersInputChange = (e) => {
    const newValue = e.target.value;
    if (!validateLetters(newValue)) {
      e.target.classList.add("input-error");
    } else {
      e.target.classList.remove("input-error");
      setname(newValue);
    }
  };

  // Function to reload the page
  let reload = () => {
    window.location.reload();
  }

  // Rendering the components
  return (
    <>
      <Top/>
      <div className="App">
        
        <div className='Container'>

          <h2> Kg to Lb </h2>
          <form onSubmit={CalcWeight}>
            <div>
              <label class='A'> Converter </label>
              <input
                type="text"
                placeholder='Enter weight to convert here'
                value={w}
                onChange={ (e) => setw(e.target.value)}
              />
            </div>

            <div>
              <button className='hello' type='submit'> Submit </button>
            </div>

            <div className='Center'>
              <h3> Weight is: {w} </h3>
            </div>

          </form>

          <h2> BMI Calculator </h2>
          <form onSubmit={calcBMI}>

            <div>
              <label class='A'> Weight (lbs) </label>
              <input 
                className={`number_place ${weight !== "" && !validateNumbers(weight) ? "input-error" : ""}`}
                type="text" 
                placeholder='Enter weight value' 
                value={weight} 
                onChange={handleNumbersWInputChange} 
              />
            </div>

            <div>
              <label class='A'> Height (in) </label>
              <input
                className={`number_place ${height !== "" && !validateNumbers(height) ? "input-error" : ""}`}
                type="text" 
                placeholder='Enter height value' 
                value={height} 
                onChange={handleNumbersHInputChange}  
              />
            </div>

            <div>
              <button className='btn' type='submit'> Submit </button>
              <button className='btn-outline' type='submit' onClick={reload}> Reload </button>
            </div>

            <div className='Center'>
              <h3> Your BMI is: {BMI} </h3>
              <p> {message} </p>
            </div>

          </form>
        </div>
        
        <div className='coontainer'>
          
          <form onSubmit={SetName}>
            <div>
              <label class='A'> Time for some advice </label>
              <input
                className={`string_place ${name !== "" && !validateLetters(name) ? "input-error" : ""}`}
                type='text'
                placeholder='Enter your name here'
                value={name}
                onChange={handleLettersInputChange}
              />
            </div>

            <div>
              <button class="B" className='hello' type='submit'> Submit </button>
            </div>

            <div className='Center'>
              {added === true ? (
                <div>
                  <p> {Bmess} </p>
                  <Lst/>
                </div>
              ) : null}
            </div>

          </form>

        </div>
      </div>
    </>
  );
}

// Exporting the App component
export default App;
